const resource = 'verified_reviews'

export default $axios => ({
  fetchSummary(params) {
    return $axios.$get(`/${resource}/summary`, {
      params,
    })
  },
  fetchSummarySkeepers(params) {
    return $axios.$get(`/${resource}/summary_skeepers`, {
      params,
    })
  },
  getServiceName: () => 'verifiedReviewsService',
})
